/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import { Row, Col, Alert } from 'react-bootstrap';
import { Select, SelectOption } from 'appkit-react';

import SourceGroupBy from './SourceGroupBy';
import TargetGroupBy from './TargetGroupBy';
import GroupByLabel from './GroupByLabel';
import RoundUpComponent from './RoundUpComponent';

const AggregateRecon = ({
    updatedConfigData, sourceColumn, onSourceColumnSelect, targetColumn,
    onTargetColumnSelect, sourceGroupBy, onSourceGroupBy, srcGroupByList,
    shouldNotShowSrcGrpByList, targetGroupBy, onTargetGroupBy, trgtGroupByList,
    shouldNotShowTrgtGrpByList, sourceRoundUp, targetRoundUp, onSourceRoundUp,
    onTargetRoundUp, sourceRoundError, targetRoundError, operation,
}) => (
    <div>
        <div className="true-comply-datarecon__sum-header">
            <p>Configure Sum Operation </p>
        </div>
        {(sourceColumn.length === 0 || targetColumn.length === 0) && (
            <div>
                <Alert variant="danger">Source Column and Target Column is required.</Alert>
            </div>
        )}
        <div>{'\n'}</div>
        <div className="true-comply-datarecon__sum-body">
            <Row>
                <Col>
                    {updatedConfigData && updatedConfigData[0] && <p className="true-comply-datarecon__reconcliationtype-sum__title">{updatedConfigData[0].fileDisplayName}</p>}
                </Col>
                <Col>
                    {updatedConfigData && updatedConfigData[1] && <p className="true-comply-datarecon__reconcliationtype-sum__title">{updatedConfigData[1].fileDisplayName}</p>}
                </Col>
            </Row>
            <Row>
                <Col>
                    <p className="true-comply-datarecon__reconcliationtype-sum__column">SOURCE COLUMN</p>
                    <div className="true-comply-datarecon__reconcliationtype-sum__select">
                        <Select
                            placeholder="Select"
                            onSelect={onSourceColumnSelect}
                            value={sourceColumn}
                        >
                            {updatedConfigData && updatedConfigData[0]
                            && updatedConfigData[0].selectedColumns && updatedConfigData[0].selectedColumns
                                .filter(item => !item.aliasName)
                                .map((c, index) => (
                                    <SelectOption key={`${c.column}_${index}`} value={c.column}>{c.displayName}</SelectOption>
                                ))}
                        </Select>
                    </div>
                </Col>
                <Col>
                    <p className="true-comply-datarecon__reconcliationtype-sum__column">TARGET COLUMN</p>
                    <div className="true-comply-datarecon__reconcliationtype-sum__select">
                        <Select
                            placeholder="Select"
                            onSelect={onTargetColumnSelect}
                            value={targetColumn}
                        >
                            {updatedConfigData && updatedConfigData[1]
                            && updatedConfigData[1].selectedColumns && updatedConfigData[1].selectedColumns
                                .filter(item => !item.aliasName)
                                .map((c, index) => (
                                    <SelectOption key={`${c.column}_${index}`} value={c.column}>{c.displayName}</SelectOption>
                                ))}
                        </Select>
                    </div>
                </Col>
            </Row>
            {operation === 'Sum' && (
                <RoundUpComponent
                    sourceRoundUp={sourceRoundUp}
                    sourceRoundError={sourceRoundError}
                    onSourceRoundUp={onSourceRoundUp}
                    targetRoundUp={targetRoundUp}
                    targetRoundError={targetRoundError}
                    onTargetRoundUp={onTargetRoundUp}
                />
            )}
            <Row>
                <SourceGroupBy
                    srcGroupByList={srcGroupByList}
                    shouldNotShowSrcGrpByList={shouldNotShowSrcGrpByList}
                    updatedConfigData={updatedConfigData}
                    sourceGroupBy={sourceGroupBy}
                    onSourceGroupBy={onSourceGroupBy}
                />
                <TargetGroupBy
                    trgtGroupByList={trgtGroupByList}
                    shouldNotShowTrgtGrpByList={shouldNotShowTrgtGrpByList}
                    updatedConfigData={updatedConfigData}
                    targetGroupBy={targetGroupBy}
                    onTargetGroupBy={onTargetGroupBy}
                />
            </Row>
            <GroupByLabel
                sourceGroupBy={sourceGroupBy}
                targetGroupBy={targetGroupBy}
            />
        </div>
    </div>
);

export default AggregateRecon;
